import { h } from "preact";
import { useState, useEffect, useRef, useCallback } from "preact/hooks";
import { Autocomplete } from "@mui/material";
import { TextField, } from "@mui/material";

const useDebouncedCallback = (func, wait) => {
    const timeout = useRef();

    return useCallback(
        (...args) => {
            const later = () => {
                clearTimeout(timeout.current);
                func(...args);
            };

            clearTimeout(timeout.current);
            timeout.current = setTimeout(later, wait);
        },
        [func, wait]
    );
};

export default function DebouncedMapBoxInput({ resultsCallback, setUpperState, upperState, mode }) {
    const [searchQuery, setSearchQuery] = useState("");
    const [searchQueryHistory, setSearchQueryHistory] = useState("");
    var url;
    switch (mode) {
        case "SE":
            url = "country=fr&types=region%2Cpostcode%2Cplace&language=fr&access_token=pk.eyJ1IjoidGVsZW1ldGlzIiwiYSI6ImNrcWZvd2c0MzByM2wybnNjOGR2c2JtNGEifQ.npIdy2KCcctfSjvVWcSDXw"
            break;
        default:
            url = "country=fr&types=address&language=fr&access_token=pk.eyJ1IjoidGVsZW1ldGlzIiwiYSI6ImNrcWZvd2c0MzByM2wybnNjOGR2c2JtNGEifQ.npIdy2KCcctfSjvVWcSDXw"


    }
    const onSearch = useDebouncedCallback(() => {

        if (searchQuery === "") { return }
        if (mode == "SE" && upperState.hit !== true) { setUpperState({ ...upperState, hit: true, manual: false, has_loc: false }) };
        if (mode == "ADR" && upperState.hit !== true) { setUpperState({ ...upperState, hit: true, manual: false, has_loc: false }) };
        if (mode == "AMB" && upperState.hit !== true) { setUpperState({ ...upperState, hit: true, manual: false, has_loc: false }) };

        if (searchQuery.length > 0 && searchQuery !== searchQueryHistory) {
            // Hit the API
            //const response = searchQuery.toUpperCase();
            fetch(
                "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
                searchQuery +
                ".json?" + url
            )
                .then((response) => {
                    return response.json();
                })
                .then((res) => {

                    setSearchQueryHistory(searchQuery);
                    setOptions(res.features);
                });
        }
    }, 500);

    useEffect(() => {
        onSearch();
    }, [searchQuery, onSearch]);

    const [options, setOptions] = useState([]);
    return (
        <div style={{ flexGrow: 2 }}>
            <Autocomplete
                //id=
                // sx={{ width: 300 }}

                autoComplete
                freeSolo
                options={options}
                getOptionLabel={(option) => option.place_name_fr}
                onInputChange={(e) => setSearchQuery(e.target.value)}
                onChange={(event, newValue) => {
                    resultsCallback(newValue);
                }}
                clearText="Effacer"
                noOptionsText={searchQuery !== "" ? <em>Désolé, nous n'avons pas trouvé d'adresse</em> : ""}
                renderInput={(params) => (

                    <TextField
                        {...params}
                        id="query"
                        name="query"

                        fullWidth
                        placeholder="Adresse"
                        margin="dense"
                        size="small"
                        style="padding: 0px; margin-top: 4px"
                        value={searchQueryHistory}
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                        }}
                    />


                )}
            />
        </div>
    );
}
